import { render } from "./FlexDataIcon.vue?vue&type=template&id=2917b18a&scoped=true"
import script from "./FlexDataIcon.vue?vue&type=script&lang=js"
export * from "./FlexDataIcon.vue?vue&type=script&lang=js"

import "./FlexDataIcon.vue?vue&type=style&index=0&id=2917b18a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2917b18a"]])

export default __exports__